import { DestroyRef, Directive, ElementRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { VisibilityService } from '@df/ui/common/visibility.service';
import { BottomPanelService } from './bottom-panel.service';

@Directive({
    selector: '[bottomPanelArea]',
    standalone: true
})
export class BottomPanelAreaDirective implements OnInit {
    @Input({ required: true })
    bottomPanelArea!: string;

    @Input()
    bottomPanelAreaThreshold = 0.0;

    protected destroyRef = inject(DestroyRef);

    constructor(
        private elementRef: ElementRef,
        private visibilityService: VisibilityService,
        private bottomPanelService: BottomPanelService
    ) {}

    ngOnInit() {
        this.visibilityService
            .isInView(this.elementRef, {
                threshold: this.bottomPanelAreaThreshold
            })
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(visible => {
                if (visible) {
                    this.bottomPanelService.onShow(this.bottomPanelArea, this);
                } else {
                    this.bottomPanelService.onHide(this.bottomPanelArea, this);
                }
            });
    }
}
